export const LOGIN = "admin/login";
export const PASSWORD_FORGET = "admin/forgot-password";
export const RESET_PASSWORD = "admin/reset-password";
export const EDIT_USER = "admin/update-profile";
export const FETCH_PROFILE = "admin/profile";

//Users
export const GET_USER_WITH_FILTER = "user/view-all";
export const DELETE_USER = "user/delete/";
export const BULK_DELETE_USER = "user/bulk-delete";
export const UPDATE_USER_STATUS = "user/update-status";


